import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

/** Layout of the help centre: a "Help centre" crumb and the read guard for every screen in it. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/help')({
  staticData: { crumb: 'common:nav.helpCenter' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'help.read');
  },
  component: Outlet,
});
